import { useParams } from "react-router-dom";
import TermsClient from "../../components/legal/TermsClient";
import { normalizeLocale } from "../../utils/locales";

export default function TermsPage() {
  const { locale } = useParams();
  const loc = normalizeLocale(locale);
  return <TermsClient locale={loc} />;
}
